import { render } from "./Identificacao.vue?vue&type=template&id=c7e8afae&ts=true"
import script from "./Identificacao.vue?vue&type=script&lang=ts"
export * from "./Identificacao.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__